import { SearchTarget } from '@/types'

export interface BibliographyAuthorityContentAuthorSearchRequest {
  searchTarget: SearchTarget
  numberOfLimit: number
  contentAuthor: string
  contentAuthorNo: string
}

export function BibliographyAuthorityContentAuthorSearchRequestToJSON(
  value: BibliographyAuthorityContentAuthorSearchRequest
): any {
  return {
    search_target: value.searchTarget ?? undefined,
    number_of_limit: value.numberOfLimit ?? undefined,
    content_author:
      value.contentAuthor !== '' ? value.contentAuthor : undefined,
    content_author_no:
      value.contentAuthorNo !== '' ? value.contentAuthorNo : undefined
  }
}
